import * as Models from "../.";
import { BaseApiResponse, IBaseApiResponse } from "../BaseApiResponse";

export interface IEpcCalculationResult extends IBaseApiResponse {
    epcCost: number;
    epcTotal: number;
    annualProduction: number;
    systemSize: number;
    escalator: Models.CostCalculation.Escalator.IEscalator;
    rate: number;
    monthlyPayment: number;
    calculationStartDate: Date;
    completionTime: Date;
    market: Models.CostCalculation.Market.IMarket;
    regionPricingId: number;
    commonUtilityCode: string;
    adderGroupCode: string;
    productName: string;
    productCode: string;
}

export class EpcCalculationResult extends BaseApiResponse implements IEpcCalculationResult {
    public epcCost: number;
    public epcTotal: number;
    public annualProduction: number;
    public systemSize: number;
    public escalator: Models.CostCalculation.Escalator.Escalator;
    public rate: number;
    public calculationStartDate: Date;
    public completionTime: Date;
    public market: Models.CostCalculation.Market.Market;
    public regionPricingId: number;
    public commonUtilityCode: string;
    public monthlyPayment: number;
    public adderGroupCode: string;
    public productName: string;
    public productCode: string;
}

export interface IOpportunityAssociatedEpcCalculationResult extends IEpcCalculationResult { 
    systemDetails?: Models.SystemDetails.SystemDetails.ISystemDetails;
    epcCalculationId: number;
    unshadedPercent: number;
}

export interface IContractAssociatedEpcCalculationResult
    extends IEpcCalculationResult {
    isReconcile: boolean;
    isPending: boolean;
    customerReferenceNumber: string; // igsCustomerNumber
    epcCalculationId: number;
    unshadedPercent: number;
    annualProdChangePercent: number;
}
